<html>

    <body class="dx-viewport">
        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->  
        <dx-box
            direction="row"
            width="100%"
            [height]="formheight"
        >
            <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx--> 
            <dxi-item
                [ratio]="4.0"
                class="rectangleinfosquare"
            >
                <dx-chart
                    #barappointmentchart
                    id="barappointmentchart"
                            
                    [dataSource]="barchart"

                    [rotated]="false"

                    palette="Dark Moon"

                    [animation]="false"

                    [customizePoint]="customizeSeries"

                    (onPointClick)="onPointClick($event)"
                    (onPointHoverChanged)="onPointHoverChanged($event)"
                >   
                    <!----------------------------------------------------------------------------------------------->
                    <dxo-title
                        [text]="barcharttitle"
                    >
                        <dxo-font
                            size="20"
                        >
                        </dxo-font>

                    </dxo-title>
                    <!----------------------------------------------------------------------------------------------->
                    <dxo-common-series-settings
                        argumentField="periodname"
                        type="bar"
                        valueField="amount"
                        [ignoreEmptyPoints]="true"

                        [minBarSize]="10"
                    >

                        <dxo-label
                            [visible]="true"
                            [format]=" {
                                        type: 'fixedPoint',
                                        precision: 0
                                    }"
                        >
                        </dxo-label> 

                    </dxo-common-series-settings>
                    <!----------------------------------------------------------------------------------------------->
                    <dxo-series-template 
                        nameField="amount"
                    >

                    </dxo-series-template>
                    <!----------------------------------------------------------------------------------------------->
                    <dxo-argument-axis
                        discreteAxisDivisionMode="crossLabels"

                       
                    >
                
                        <dxo-label
                            [visible]="true"

                            position="outside"

                            displayMode="rotate"

                            [rotationAngle]="90"

                            alignment="center"

                        >

                        </dxo-label>
                      
                    </dxo-argument-axis>
                    <!----------------------------------------------------------------------------------------------->
                    <dxo-tooltip
                        [enabled]="charttooltip"
                        [customizeTooltip]="customizeTooltip"
                    >
                    </dxo-tooltip>
                    <!----------------------------------------------------------------------------------------------->
                    <dxo-legend 
                        [visible]="false"
                        position="inside"
                        horizontalAlignment="right"
                        verticalAlignment="top"
                        orientation="vertical"
                    >
                    </dxo-legend>
                    <!----------------------------------------------------------------------------------------------->
                    
                </dx-chart>

            </dxi-item>
            <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx--> 
            <dxi-item
                [ratio]="0.008"
            >
            </dxi-item>
            <!----------------------------------------------------------------------------------------------->
            <dxi-item
                [ratio]="1.5"
                class="rectangleinfosquare"
            >

                <dx-scheduler
                    #scheduleragenda
                    id="scheduleagenda"

                    [dataSource]="subscriptionschedulerlist"

                    [views]="['agenda']"
                    currentView="agenda"

                    [currentDate]="currentDate"

                    [startDayHour]="8"
                    height="98%"


                    (onContentReady)="onContentReady($event)"

           
                    [customizeDateNavigatorText]="customizeAgendaDateNavigatorText"
                    appointmentTemplate="appointment-agendatemplate"
                >

                    <!------------------------------------------------------------------------->
                    <dxi-view
                        type="agenda"
                        [agendaDuration]="agendaageduration"
                    
                        dateCellTemplate="agendadateCellTemplate"

                     >
                    </dxi-view>
                    <!------------------------------------------------------------------------->
                    <div *dxTemplate="let data of 'agendadateCellTemplate'">
                        <div class="fontsize12">
                            {{data.date | date: 'EEEE' }} 
                            <br>
                            {{data.date | date: dateformat}}
                        </div>
                    
                    </div>
                    <!------------------------------------------------------------------------->
                    <div *dxTemplate="let modelagenda of 'appointment-agendatemplate'">

                        {{modelagenda.targetedAppointmentData.title}}
                        <br>
                        {{modelagenda.targetedAppointmentData.startDate | date:'shortTime'}}-{{modelagenda.targetedAppointmentData.endDate | date:'shortTime'}}
                    
                    </div>
                    <!------------------------------------------------------------------------->

                </dx-scheduler>

            </dxi-item>
            <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
        </dx-box>
        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx--> 
    </body>

</html>